import React, {useState} from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import {FormattedMessage} from "react-intl";

import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import SvgIcon from "@mui/material/SvgIcon";
import FormHelperText from "@mui/material/FormHelperText";

import {ROUTES} from "../../../../../routes";
import GroheCartStickyFooter from "../groheCartStickyFooter";
import {restorePaymentInfo, setBillingInfo} from "../../../../../actions/paymentFunctions";
import GroheCartHeaderCommon from "../groheCartHeaderCommon";
import GroheCartBackButton from "../groheCartBackButton";
import {postVerifyAddress} from "../../../../../api/look-api";
import {COLORS} from "../../../../../colorThemes";
import {GroheNoteAddIcon} from "../../../../common/icons";
import GroheBillingAndShippingInputs from "./groheBillingAndShippingInputs";


const GroheCartBillingInfo = (props) => {

  const {isMobile, history, billingAddress, setBillingInfo, restorePaymentInfo} = props;
  const [defaultValues] = useState(billingAddress);
  const [isLoading, setIsLoading] = useState(false);
  const [addressError, setAddressError] = useState("");

  const disabled = !billingAddress.address1;

  const backButtonClick = () => {
    restorePaymentInfo({
      billingAddress: defaultValues
    });
    history.push(ROUTES.cartBilling);
  };

  const confirmButtonClick = async () => {
    setIsLoading(true);
    const addressValidated = await postVerifyAddress(billingAddress);
    setIsLoading(false);
    if (addressValidated && addressValidated.isConfirmed
      && (addressValidated.isConfirmed === "Y" || addressValidated.isConfirmed === "D")) {
      history.push(ROUTES.cartBilling);
      return true
    }
    setAddressError(addressValidated.errorDescription || " ");
    return false
  };

  const stickyFooterButtons = [
    {
      translate: "buttons.back",
      classes: "look-button--secondary",
      onClick: () => {
        history.push(ROUTES.cartBilling);
      }
    },
    {
      translate: "grohe.cart.shipping.submitButton",
      classes: "look-button--blue gc-sticky__button--60",
      onClick: confirmButtonClick,
      disabled
    },
  ];

  return (
    <div className="gc">
      <div className="gc-body">
        <GroheCartHeaderCommon title="grohe.cart.billingSection.title" subTitle="grohe.cart.billingSection.subTitle"/>
        <GroheBillingAndShippingInputs addressObject={billingAddress}
                                       setAddressInfo={setBillingInfo}
                                       // addressErrors={shippingErrors}
                                       // setAddressErrors={setShippingErrors}
        />
        {addressError ? (
          <FormHelperText className="gc-content MuiFormHelperText-root Mui-error MuiFormHelperText-sizeSmall MuiFormHelperText-contained">
            <FormattedMessage id="look.inputs.errors.incorrectAddress"/>
            {" " + addressError}
          </FormHelperText>
        ) : null}
        {isMobile ? null : (
          <div className="gc-content">
            <div className="gc-form__submit">
              <div className="gc-form__submit-left"/>
              {isMobile ? null : (
                <div className="gc-form__submit-right">
                  <GroheCartBackButton backButtonClick={backButtonClick}/>
                  <Button className={"look-button look-button--blue look-button--big look-button--large nowrap"
                    + (isLoading ? " grohe-look__button--loading" : "")}
                          disabled={disabled}
                          startIcon={isLoading
                            ? <CircularProgress className="grohe-look__button-loader-small" style={{'color': COLORS.white}}/>
                            : (
                              <SvgIcon>
                                <GroheNoteAddIcon color={COLORS.white}/>
                              </SvgIcon>
                            )}
                          onClick={confirmButtonClick}>
                    <FormattedMessage id="grohe.cart.shipping.submitButton"/>
                  </Button>
                </div>
              )}
            </div>
          </div>
        )}
        {isMobile ? <div className="gc-spacer"/> : null}
      </div>
      {isMobile ? <GroheCartStickyFooter stickyFooterButtons={stickyFooterButtons}/> : null}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  const {billingAddress} = store.paymentState;

  return {
    isMobile,
    billingAddress,
  };
};

const mapDispatchToProps = {
  setBillingInfo,
  restorePaymentInfo,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GroheCartBillingInfo))
